import { render } from "./ClientsAddView.vue?vue&type=template&id=4b6f81e7"
import script from "./ClientsAddView.vue?vue&type=script&lang=js"
export * from "./ClientsAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__